import Logo from './Logo';
import SyncIcon from '@atlaskit/icon-lab/core/sync';
import AtlassianUserIcon from './AtlassianUserIcon';
import { Inline } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const AppLogos = () => {
  return (
    <Inline alignBlock="center" space="space.100">
      <AtlassianUserIcon />
      <SyncIcon label="" color={token('color.icon')} />
      <Logo />
    </Inline>
  );
};

export default AppLogos;
